// Copyright 2016 Sorama B.V.

import { Unit, UnitType } from "units/Unit";

export class Data extends UnitType {
    public static override typeName = "Data";

    public static bit: Unit = new Unit("b", 1 / 8, Data);
    public static byte: Unit = new Unit("B", 1, Data);
}

export class DecimalData extends Data {
    public static override typeName = "DecimalData";

    // Bit and Byte for use with string identification for the UnitParser to explicitly indicate a decimal version is required.
    // Used for the UnitValueToHumanReadableUnitValueConverter.
    public static decimalbit: Unit = new Unit("b", 1 / 8, DecimalData, { unitFamily: Data });
    public static decimalbyte: Unit = new Unit("B", 1, DecimalData, { unitFamily: Data });

    public static kilobyte: Unit = new Unit("kB", 1e3, DecimalData, { unitFamily: Data });
    public static megabyte: Unit = new Unit("MB", 1e6, DecimalData, { unitFamily: Data });
    public static gigabyte: Unit = new Unit("GB", 1e9, DecimalData, { unitFamily: Data });
    public static terabyte: Unit = new Unit("TB", 1e12, DecimalData, { unitFamily: Data });
}

export class BinaryData extends Data {
    public static override typeName = "BinaryData";

    // Bit and Byte for use with string identification for the UnitParser to explicitly indicate a binary version is required.
    // Used for the UnitValueToHumanReadableUnitValueConverter.
    public static binarybit: Unit = new Unit("b", 1 / 8, BinaryData, { unitFamily: Data });
    public static binarybyte: Unit = new Unit("B", 1, BinaryData, { unitFamily: Data });

    public static kibibyte: Unit = new Unit("KiB", 1024, BinaryData, { unitFamily: Data });
    public static mebibyte: Unit = new Unit("MiB", Math.pow(1024, 2), BinaryData, { unitFamily: Data });
    public static gibibyte: Unit = new Unit("GiB", Math.pow(1024, 3), BinaryData, { unitFamily: Data });
    public static tebibyte: Unit = new Unit("TiB", Math.pow(1024, 4), BinaryData, { unitFamily: Data });
}
